import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Container } from '@sorare/core/src/atoms/layout/Container';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import {
  BodyM,
  BrandXXL,
  HeadlineXL,
  LabelL,
} from '@sorare/core/src/atoms/typography';
import { FRONTEND_ASSET_HOST } from '@sorare/core/src/constants/assets';
import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';
import {
  largeDesktopAndAbove,
  tabletAndAbove,
} from '@sorare/core/src/style/mediaQuery';

const press = `${FRONTEND_ASSET_HOST}/pages/press/press.jpg`;

const TextContainer = styled(BodyM)`
  flex: 1;
`;

const FoundersHeadline = styled(HeadlineXL)`
  padding: var(--quarter-unit);
  max-width: calc(var(--unit) * 60);
  @media ${tabletAndAbove} {
    max-width: calc(var(--unit) * 100);
  }
`;

const AboutSorareContainer = styled(LabelL)`
  padding: var(--quarter-unit);
  max-width: calc(var(--unit) * 60);
  line-height: 1.7;
  @media ${tabletAndAbove} {
    max-width: calc(var(--unit) * 100);
  }
`;

const ImageContainer = styled(Vertical).attrs({
  center: true,
})`
  width: calc(80 * var(--vw));
  height: 600px;
  border-radius: var(--half-unit);
  mask-image: linear-gradient(to bottom, black 40%, transparent 100%);
  @media ${largeDesktopAndAbove} {
    height: 1700px;
  }
`;

const StyledImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: var(--c-nd-100-opaque);

  transition: transform 0.3s ease-in-out;
  &:hover {
    transform: scale(1.015);
  }
`;

const ContactContainer = styled(Vertical)`
  align-self: flex-start;
`;

export const Intro = () => {
  const isLaptop = useIsLaptop();

  return (
    <Container maxWidth={isLaptop ? 800 : 500}>
      <Vertical gap={isLaptop ? 6 : 4} center>
        <ContactContainer>
          <BrandXXL>
            <FormattedMessage defaultMessage="Press" />
          </BrandXXL>
          <TextContainer>
            <FormattedMessage
              defaultMessage="Reach out to {email} for any media inquiries."
              values={{
                email: (
                  <i>
                    <a href="mailto:press@sorare.com">press@sorare.com</a>
                  </i>
                ),
              }}
            />
          </TextContainer>
        </ContactContainer>
        <FoundersHeadline bold>
          <FormattedMessage defaultMessage="Sorare was founded in 2018 in Paris by Nicolas Julia and Adrien Montfort to bring sports fans around the world closer to their favorite players, teams, and leagues." />
        </FoundersHeadline>
        <Horizontal gap={4}>
          <AboutSorareContainer>
            <FormattedMessage defaultMessage="Sorare is a fantasy sports platform and digital marketplace where fans collect, trade, and play with officially licensed digital cards. Build your dream team and compete in fantasy games to win daily and weekly rewards, just like a professional sports manager." />
          </AboutSorareContainer>
        </Horizontal>
        <ImageContainer>
          <StyledImg src={press} alt="" />
        </ImageContainer>
      </Vertical>
    </Container>
  );
};
